// extracted by mini-css-extract-plugin
module.exports = {"articleTitle":"ArticleHeader_articleTitle__GRRYz","articleDate":"ArticleHeader_articleDate__N4j_Z","componentStyle":"ArticleHeader_componentStyle__nOioo"};